import React from "react";

export const Logo = ({ className = "" }) => {
    return (
        <div
            data-testid="brand-logo"
            className={`font-display text-3xl sm:text-4xl uppercase tracking-tight leading-none ${className}`}
        >
            <span className="text-white">KYLIE</span>
            <span className="kw-orange ml-1">WEST</span>
        </div>
    );
};

export default Logo;
